import { Flex, Text } from '@chakra-ui/react';

import { CountryFlag } from '../CountryFlag';

export const FlagCell = ({ alpha3 }: { alpha3?: string }) => {
    if (!alpha3) {
        return null;
    }

    return (
        <Flex alignItems="center" gap={1}>
            <CountryFlag alpha3={alpha3} />
            <Text>{alpha3}</Text>
        </Flex>
    );
};
